"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[7292],{

/***/ 46877:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

/* harmony default export */ __webpack_exports__["Z"] = ({"src":"/_next/static/media/jocelyn-profile.cc2587af.jpg","height":200,"width":200,"blurDataURL":"data:image/jpeg;base64,/9j/2wBDAAoHBwgHBgoICAgLCgoLDhgQDg0NDh0VFhEYIx8lJCIfIiEmKzcvJik0KSEiMEExNDk7Pj4+JS5ESUM8SDc9Pjv/2wBDAQoLCw4NDhwQEBw7KCIoOzs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozv/wAARCAAIAAgDASIAAhEBAxEB/8QAFAABAAAAAAAAAAAAAAAAAAAAAP/EAB0QAAAHAAMAAAAAAAAAAAAAAAABAgMEERIhIlH/xAAUAQEAAAAAAAAAAAAAAAAAAAAE/8QAGxEBAAEFAQAAAAAAAAAAAAAAAQACAwQTIWH/2gAMAwEAAhEDEQA/AByltz0Idc0xdUauuc8FXugAAfWIdinFttI+T//Z"});

/***/ }),

/***/ 35540:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "w": function() { return /* reexport */ InsuranceLogos; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(25675);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
;// CONCATENATED MODULE: ./public/images/landing_page/insurance/aetna.png
/* harmony default export */ var aetna = ({"src":"/_next/static/media/aetna.c728b64a.png","height":64,"width":233,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAACCAMAAABSSm3fAAAAD1BMVEX///////////////////+Rd1MVAAAABXRSTlN1aVdDiOSz/mYAAAAJcEhZcwAAFiUAABYlAUlSJPAAAAAZSURBVHicBcEBAQAAAIIgrf5vDsAmadFN4AEbABx4X4GEAAAAAElFTkSuQmCC"});
;// CONCATENATED MODULE: ./public/images/landing_page/insurance/anthem.png
/* harmony default export */ var anthem = ({"src":"/_next/static/media/anthem.f1c31c08.png","height":56,"width":298,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAACCAMAAABSSm3fAAAAElBMVEX///////////////////////+65XQCAAAABnRSTlMXKmtSWT+lBEPrAAAACXBIWXMAABYlAAAWJQFJUiTwAAAAGklEQVR4nGNgZGBkYGBkYmJgZWFmZmFlYgYAAPMAJbRcMxkAAAAASUVORK5CYII="});
;// CONCATENATED MODULE: ./public/images/landing_page/insurance/bsbs.png
/* harmony default export */ var bsbs = ({"src":"/_next/static/media/bsbs.db1f9d2f.png","height":64,"width":301,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAACCAMAAABSSm3fAAAAGFBMVEX////////////LzM7OztDR0dP////BwcNUGzKIAAAACHRSTlNGXU+gj3UsdB1n5M4AAAAJcEhZcwAAFiUAABYlAUlSJPAAAAAaSURBVHicY2BmYWZiYGJgY2BmZWdgZGRkAgABkgAp1vwAawAAAABJRU5ErkJggg=="});
;// CONCATENATED MODULE: ./public/images/landing_page/insurance/uhc.png
/* harmony default export */ var uhc = ({"src":"/_next/static/media/uhc.da13deff.png","height":64,"width":323,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAACCAMAAABSSm3fAAAAFVBMVEX////////////////////////+/v4IluoxAAAAB3RSTlMrCztCGmp3VTcvyAAAAAlwSFlzAAAWJQAAFiUBSVIk8AAAABpJREFUeJxjYGVgYmJmYmBgYGNgZmFkZGQEAAFAACCr+tkKAAAAAElFTkSuQmCC"});
;// CONCATENATED MODULE: ./public/images/landing_page/insurance/cigna.png
/* harmony default export */ var cigna = ({"src":"/_next/static/media/cigna.0f8dfdf5.png","height":80,"width":191,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAADCAMAAACZFr56AAAAElBMVEX///////////////////////+65XQCAAAABnRSTlNYIAsFbz69dI0mAAAACXBIWXMAABYlAAAWJQFJUiTwAAAAHUlEQVR4nAXBAQEAAAzCoDl9/8oHMpIqGccAuRp9AmgALr6KfRUAAAAASUVORK5CYII="});
;// CONCATENATED MODULE: ./public/images/landing_page/insurance/aetna-mobile.png
/* harmony default export */ var aetna_mobile = ({"src":"/_next/static/media/aetna-mobile.d37ffa11.png","height":64,"width":197,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAADCAMAAACZFr56AAAAD1BMVEX///////////////////+Rd1MVAAAABXRSTlMIARp+aKnDsaEAAAAJcEhZcwAAFiUAABYlAUlSJPAAAAAdSURBVHicFcKBDQAADMKgdvr/zYsEhBXSJBW58QEBuwAme3dCrQAAAABJRU5ErkJggg=="});
;// CONCATENATED MODULE: ./public/images/landing_page/insurance/anthem-mobile.png
/* harmony default export */ var anthem_mobile = ({"src":"/_next/static/media/anthem-mobile.9f9fb173.png","height":64,"width":198,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAADCAMAAACZFr56AAAAFVBMVEX///////////9MaXH///////////+tVghgAAAAB3RSTlMUB0EAUWmMgyxIpgAAAAlwSFlzAAAWJQAAFiUBSVIk8AAAAB1JREFUeJxjYGRmZGZmZGBgYGJiYWJiYWNlgAJGAAKNACkjE+2oAAAAAElFTkSuQmCC"});
;// CONCATENATED MODULE: ./public/images/landing_page/insurance/bsbs-mobile.png
/* harmony default export */ var bsbs_mobile = ({"src":"/_next/static/media/bsbs-mobile.c5991e5d.png","height":64,"width":197,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAADCAMAAACZFr56AAAAHlBMVEX////x8fH9/f3R09XIycv+/v7////+/v7////S09X1eseTAAAACnRSTlMZER8wsl1MZWK99Bzz8wAAAAlwSFlzAAAWJQAAFiUBSVIk8AAAACBJREFUeJwFwYEBADAIwrACbur/D5uQxIDYqjc9HyRhcwQEAEeMHkACAAAAAElFTkSuQmCC"});
;// CONCATENATED MODULE: ./public/images/landing_page/insurance/uhc-mobile.png
/* harmony default export */ var uhc_mobile = ({"src":"/_next/static/media/uhc-mobile.d1ca94c3.png","height":64,"width":197,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAADCAMAAACZFr56AAAAFVBMVEX///////////////9MaXH///////8nZ1FQAAAAB3RSTlMuDwkVAE2Nh7kRRQAAAAlwSFlzAAAWJQAAFiUBSVIk8AAAAB9JREFUeJxjYGZkYmZmZGRiYGNgZQADZkZmJhYWFhYAApwANRho8a0AAAAASUVORK5CYII="});
;// CONCATENATED MODULE: ./public/images/landing_page/insurance/cigna-mobile.png
/* harmony default export */ var cigna_mobile = ({"src":"/_next/static/media/cigna-mobile.9c381aa1.png","height":64,"width":197,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAADCAMAAACZFr56AAAAElBMVEX///////////////////////+65XQCAAAABnRSTlMERCMRVHaQlj7AAAAACXBIWXMAABYlAAAWJQFJUiTwAAAAGUlEQVR4nGNgYGBkZgADJlZGRhYmMAssAAABUAAWcJxtUgAAAABJRU5ErkJggg=="});
;// CONCATENATED MODULE: ./components/page-sections/Insurance/InsuranceLogos.tsx












function InsuranceLogos() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("section", {
        className: "flex justify-center px-8",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "flex flex-col items-center justify-center md:hidden",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                        className: "text-base text-center font-inter text-dawnDark-200",
                        children: "Accepted by"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "grid grid-cols-6 gap-4 mt-8",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "col-span-2",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                    src: aetna_mobile,
                                    height: 32,
                                    width: 98,
                                    alt: "aetna"
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "col-span-2",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                    src: anthem_mobile,
                                    height: 32,
                                    width: 98,
                                    alt: "anthem"
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "col-span-2",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                    src: cigna_mobile,
                                    height: 32,
                                    width: 98,
                                    alt: "cigna"
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "col-span-2 col-start-2 cold-end-4",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                    src: uhc_mobile,
                                    height: 32,
                                    width: 98,
                                    alt: "united healthcare"
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "col-span-2",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                    src: bsbs_mobile,
                                    height: 32,
                                    width: 98,
                                    alt: "blue cross blue shield"
                                })
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "flex-wrap items-center justify-center hidden gap-12 md:flex",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                        className: "text-lg text-center font-inter text-dawnDark-200",
                        children: "Accepted by"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                        src: aetna,
                        height: 32,
                        width: 116,
                        alt: "aetna"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                        src: anthem,
                        height: 28,
                        width: 148,
                        alt: "anthem"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                        src: cigna,
                        height: 40,
                        width: 95,
                        alt: "cigna"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                        src: uhc,
                        height: 32,
                        width: 161,
                        alt: "united healthcare"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                        src: bsbs,
                        height: 32,
                        width: 150,
                        alt: "blue cross blue shield"
                    })
                ]
            })
        ]
    });
}

;// CONCATENATED MODULE: ./components/page-sections/Insurance/index.ts



/***/ }),

/***/ 47849:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "p": function() { return /* reexport */ Intro; },
  "O": function() { return /* reexport */ IntroBase; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./components/Link/index.ts + 1 modules
var Link = __webpack_require__(504);
// EXTERNAL MODULE: ./modules/sanity/SanityImage.tsx
var SanityImage = __webpack_require__(88114);
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(94184);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./components/Navbar/Navbar.tsx + 6 modules
var Navbar = __webpack_require__(92595);
// EXTERNAL MODULE: ./components/Gradient/index.ts + 1 modules
var Gradient = __webpack_require__(1824);
// EXTERNAL MODULE: ./components/page-sections/Testimonials/index.ts + 1 modules
var Testimonials = __webpack_require__(39021);
// EXTERNAL MODULE: ./components/page-sections/InThePress/index.ts + 5 modules
var InThePress = __webpack_require__(33732);
;// CONCATENATED MODULE: ./components/page-sections/Intro/Intro.tsx








function Intro(param) {
    var title = param.title, text = param.text, _showCallToAction = param.showCallToAction, showCallToAction = _showCallToAction === void 0 ? true : _showCallToAction, _callToActionText = param.callToActionText, callToActionText = _callToActionText === void 0 ? "Get Started" : _callToActionText, _showTestimonials = param.showTestimonials, showTestimonials = _showTestimonials === void 0 ? false : _showTestimonials, _showInThePressLogos = param.showInThePressLogos, showInThePressLogos = _showInThePressLogos === void 0 ? false : _showInThePressLogos, showHeaderMedia = param.showHeaderMedia, image = param.image, youtubeVideoId = param.youtubeVideoId, internalLinkCallToAction = param.internalLinkCallToAction;
    var buildCallToActionUrl = function buildCallToActionUrl(internalLinkCallToAction) {
        if (internalLinkCallToAction) {
            switch(internalLinkCallToAction._type){
                case "questionnaire":
                    return "/questionnaire/".concat(internalLinkCallToAction.slug.current);
                case "page":
                    return "/".concat(internalLinkCallToAction.slug.current);
                case "post":
                    return "/blog/".concat(internalLinkCallToAction.slug.current);
            }
        }
        return "/questionnaire";
    };
    var hasHeaderMedia = showHeaderMedia && showHeaderMedia !== "none" && (image || youtubeVideoId);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(IntroBase, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("section", {
            className: "py-22 xl:pt-30 xl:pb-30",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "flex justify-center text-white",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: classnames_default()("flex justify-between flex-1 max-w-7xl md:px-7 mx-6", {
                            "xl:flex-row xl:items-center": hasHeaderMedia,
                            "flex-col-reverse": hasHeaderMedia && showHeaderMedia === "image",
                            "flex-col": hasHeaderMedia && showHeaderMedia === "youtubeEmbed"
                        }),
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: classnames_default()("w-full", {
                                    "xl:w-7/12 xl:pr-8 xl:mt-0": hasHeaderMedia
                                }),
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h1", {
                                        className: classnames_default()("xl:text-5.5xl text-5xl leading-12  xl:leading-18 font-semibold text-center xl:text-left", {
                                            "xl:text-center max-w-3xl mx-auto": !hasHeaderMedia
                                        }),
                                        children: title
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                        className: classnames_default()("font-inter mt-4 text-base text-center xl:leading-8 xl:text-xl xl:text-left", {
                                            "xl:text-center max-w-1.5xl mx-auto": !hasHeaderMedia,
                                            "xl:max-w-lg": hasHeaderMedia
                                        }),
                                        children: text
                                    }),
                                    showCallToAction && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: classnames_default()("flex justify-center mt-10 xl:justify-start xl:mt-6", {
                                            "xl:justify-center": !hasHeaderMedia
                                        }),
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Link/* Link */.r, {
                                            href: buildCallToActionUrl(internalLinkCallToAction),
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                className: "flex items-center justify-center flex-1 max-w-md px-8 py-4 text-sm font-medium tracking-widest text-white uppercase rounded-full xl:flex-none bg-gradient-to-tr from-dawnOrange-500 to-dawnPurple-500 xl:py-6 md:text-base",
                                                children: callToActionText
                                            })
                                        })
                                    })
                                ]
                            }),
                            showHeaderMedia === "image" && image && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "relative mb-10 overflow-hidden xl:flex-1 rounded-xl h-80",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(SanityImage/* default */.Z, {
                                    image: image,
                                    fill: true,
                                    width: 400
                                })
                            }),
                            showHeaderMedia === "youtubeEmbed" && youtubeVideoId && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "relative xl:pt-[28.5%] pt-[56.2%] w-full xl:w-[60%] overflow-hidden mt-10 xl:mt-0",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("iframe", {
                                    className: "absolute inset-0 w-full h-full rounded-xl",
                                    src: "https://www.youtube.com/embed/".concat(youtubeVideoId),
                                    title: "YouTube video player",
                                    frameBorder: "0",
                                    allowFullScreen: true
                                })
                            })
                        ]
                    })
                }),
                showInThePressLogos && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(InThePress/* InThePressLogos */.P, {})
                }),
                showTestimonials && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "xl:mt-30 mt-22",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Testimonials/* TestimonialCarousel */.N, {})
                })
            ]
        })
    });
}
function IntroBase(param) {
    var children = param.children;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "overflow-hidden bg-dawnDark-700",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "relative",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Gradient/* Gradient */.p, {
                        color: "purple",
                        scale: 7,
                        opacity: 0.25,
                        left: "-50rem"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Gradient/* Gradient */.p, {
                        color: "orange",
                        scale: 8,
                        opacity: 0.15,
                        left: "-60rem",
                        top: "10rem"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Gradient/* Gradient */.p, {
                        color: "purple",
                        scale: 7,
                        opacity: 0.25,
                        right: "-30rem",
                        top: "-20rem"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Gradient/* Gradient */.p, {
                        color: "orange",
                        scale: 7,
                        opacity: 0.1,
                        right: "-40rem",
                        top: "-2rem"
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "relative",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Navbar/* default */.Z, {}),
                    children
                ]
            })
        ]
    });
}

;// CONCATENATED MODULE: ./components/page-sections/Intro/index.ts



/***/ }),

/***/ 54124:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "p": function() { return /* binding */ Quote; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(25675);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_image__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var modules_sanity_SanityImage__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(88114);



function Quote(param) {
    var text = param.text, source = param.source, sourceTitle = param.sourceTitle, sourceImage = param.sourceImage, sourceImageStatic = param.sourceImageStatic;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("section", {
        className: "flex justify-center py-22 md:py-30",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
            className: "max-w-1.5xl mx-8",
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("svg", {
                    className: "w-10 mx-auto md:w-13",
                    viewBox: "0 0 52 36",
                    fill: "none",
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                            d: "M13.5823 15.756C16.521 15.756 18.877 16.6173 20.6503 18.34C22.4236 20.012 23.3103 22.3173 23.3103 25.256C23.3103 28.0933 22.3476 30.4747 20.4223 32.4C18.497 34.2747 15.7356 35.212 12.1383 35.212C8.43965 35.212 5.60231 33.9707 3.62631 31.488C1.65031 29.0053 0.662313 25.8387 0.662313 21.988C0.662313 18.2893 1.54898 15.0213 3.32231 12.184C5.09565 9.29599 7.35031 6.86399 10.0863 4.888C12.8223 2.912 15.5836 1.36666 18.3703 0.251991L20.4223 4.58399C17.4836 5.648 14.7476 7.42133 12.2143 9.904C9.68098 12.3867 8.36365 14.9707 8.26231 17.656C8.46498 17.3013 9.04765 16.896 10.0103 16.44C10.973 15.984 12.1636 15.756 13.5823 15.756ZM41.3983 15.756C44.337 15.756 46.693 16.6173 48.4663 18.34C50.2396 20.012 51.1263 22.3173 51.1263 25.256C51.1263 28.0933 50.1636 30.4747 48.2383 32.4C46.313 34.2747 43.5516 35.212 39.9543 35.212C36.2556 35.212 33.4183 33.9707 31.4423 31.488C29.4663 29.0053 28.4783 25.8387 28.4783 21.988C28.4783 18.2893 29.365 15.0213 31.1383 12.184C32.9116 9.29599 35.1663 6.86399 37.9023 4.888C40.6383 2.912 43.3996 1.36666 46.1863 0.251991L48.2383 4.58399C45.2996 5.648 42.5636 7.42133 40.0303 9.904C37.497 12.3867 36.1796 14.9707 36.0783 17.656C36.281 17.3013 36.8636 16.896 37.8263 16.44C38.789 15.984 39.9796 15.756 41.3983 15.756Z",
                            fill: "url(#paint0_linear_311:3561)"
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("defs", {
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("linearGradient", {
                                id: "paint0_linear_311:3561",
                                x1: "56.5",
                                y1: "-2",
                                x2: "31.1043",
                                y2: "54.1136",
                                gradientUnits: "userSpaceOnUse",
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("stop", {
                                        offset: "0.166667",
                                        stopColor: "#FF8F5B"
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("stop", {
                                        offset: "0.822917",
                                        stopColor: "#536DE2"
                                    })
                                ]
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                    className: "mt-4 text-lg leading-8 text-center md:text-2xl md:leading-10",
                    children: text
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    className: "flex justify-center",
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        className: "flex items-center mt-4 space-x-4",
                        children: [
                            sourceImage && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                className: "relative w-10 h-10 overflow-hidden rounded-full md:w-14 md:h-14",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(modules_sanity_SanityImage__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                                    image: sourceImage,
                                    width: 100
                                })
                            }),
                            sourceImageStatic && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                className: "w-10 h-10 overflow-hidden rounded-full md:w-12 md:h-12",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_1___default()), {
                                    src: sourceImageStatic,
                                    alt: ""
                                })
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                className: "flex-1 text-base leading-6 md:text-xl md:leading-8",
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                        className: "font-semibold md:inline-block",
                                        children: [
                                            source,
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                                className: "hidden md:inline-block md:mr-1",
                                                children: ","
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                        className: "text-xs md:text-xl md:leading-8 md:inline-block text-dawnDark-700",
                                        children: sourceTitle
                                    })
                                ]
                            })
                        ]
                    })
                })
            ]
        })
    });
}


/***/ }),

/***/ 41697:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "$r": function() { return /* binding */ usePreviewSubscription; },
/* harmony export */   "i3": function() { return /* binding */ sanityClient; },
/* harmony export */   "vc": function() { return /* binding */ config; }
/* harmony export */ });
/* unused harmony export useCurrentUser */
/* harmony import */ var next_sanity__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(81035);

var config = {
    projectId: "4jrvqlog",
    dataset: "production",
    apiVersion: "2021-07-21",
    useCdn: "production" === "production"
};
var usePreviewSubscription = (0,next_sanity__WEBPACK_IMPORTED_MODULE_0__/* .createPreviewSubscriptionHook */ .KF)(config);
var useCurrentUser = (0,next_sanity__WEBPACK_IMPORTED_MODULE_0__/* .createCurrentUserHook */ .Iy)(config);
var sanityClient = (0,next_sanity__WEBPACK_IMPORTED_MODULE_0__/* .createClient */ .eI)(config);


/***/ }),

/***/ 88114:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ SanityImage; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(69396);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(25675);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_image__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var next_sanity_image__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(61202);
/* harmony import */ var lib_sanity__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(41697);






function SanityImage(param) {
    var image = param.image, className = param.className, _fill = param.fill, fill = _fill === void 0 ? false : _fill, _width = param.width, width = _width === void 0 ? 800 : _width, _sizes = param.sizes, sizes = _sizes === void 0 ? "(max-width: 800px) 100vw, 800px" : _sizes;
    var imageProps = (0,next_sanity_image__WEBPACK_IMPORTED_MODULE_2__/* .useNextSanityImage */ .J)(lib_sanity__WEBPACK_IMPORTED_MODULE_3__/* .sanityClient */ .i3, image, {
        imageBuilder: function(imageUrlBuilder, options) {
            return imageUrlBuilder.width(Math.min(width, options.width));
        }
    });
    return fill ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_1___default()), {
        src: imageProps.src,
        alt: image.alt,
        loader: imageProps.loader,
        layout: "fill",
        sizes: sizes,
        objectFit: "cover",
        className: className
    }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_1___default()), (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({}, imageProps), {
        alt: image.alt,
        layout: "responsive",
        sizes: sizes,
        className: className
    }));
};


/***/ }),

/***/ 17292:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ Pricing; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/next/head.js
var head = __webpack_require__(9008);
var head_default = /*#__PURE__*/__webpack_require__.n(head);
// EXTERNAL MODULE: ./components/page-sections/Intro/index.ts + 1 modules
var Intro = __webpack_require__(47849);
// EXTERNAL MODULE: ./components/page-sections/CallToAction/index.ts + 1 modules
var CallToAction = __webpack_require__(31437);
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(94184);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
;// CONCATENATED MODULE: ./modules/pricing/PricingFeatureComparison.tsx


var features = [
    "No Side Effects",
    "In-Home on Your Terms",
    "Unlimited Coach Messaging",
    "Long-term Benefits",
    "Personalized", 
];
function PricingFeatureComparisonColumn(param) {
    var title = param.title, featuresChecked = param.featuresChecked, cost = param.cost, _isHighlighted = param.isHighlighted, isHighlighted = _isHighlighted === void 0 ? false : _isHighlighted;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: classnames_default()("flex flex-col items-center rounded-3xl xl:w-[148px] p-6 xl:p-0 w-full", {
            "bg-dawnDark-700": isHighlighted
        }),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "px-5 py-6 text-center",
                children: title
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("ul", {
                className: "flex flex-col w-full h-full space-y-6 xl:items-center xl:justify-evenly",
                children: [
                    features.map(function(feature, index) {
                        return /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                            className: "flex",
                            children: [
                                featuresChecked.includes(index) ? /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
                                    className: "w-6 h-6 stroke-current text-dawnOrange-500",
                                    viewBox: "0 0 24 24",
                                    fill: "none",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                        d: "M4 12L10 18L20 6",
                                        stroke: "current",
                                        strokeWidth: "2",
                                        strokeLinecap: "round",
                                        strokeLinejoin: "round"
                                    })
                                }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
                                    className: "w-6 h-6 fill-current text-dawnDark-400",
                                    viewBox: "0 0 24 24",
                                    fill: "none",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                        d: "M5.29279 5.29308C5.48031 5.10561 5.73462 5.00029 5.99979 5.00029C6.26495 5.00029 6.51926 5.10561 6.70679 5.29308L11.9998 10.5861L17.2928 5.29308C17.385 5.19757 17.4954 5.12139 17.6174 5.06898C17.7394 5.01657 17.8706 4.98898 18.0034 4.98783C18.1362 4.98668 18.2678 5.01198 18.3907 5.06226C18.5136 5.11254 18.6253 5.18679 18.7192 5.28069C18.8131 5.37458 18.8873 5.48623 18.9376 5.60913C18.9879 5.73202 19.0132 5.8637 19.012 5.99648C19.0109 6.12926 18.9833 6.26048 18.9309 6.38249C18.8785 6.50449 18.8023 6.61483 18.7068 6.70708L13.4138 12.0001L18.7068 17.2931C18.8889 17.4817 18.9897 17.7343 18.9875 17.9965C18.9852 18.2587 18.88 18.5095 18.6946 18.6949C18.5092 18.8803 18.2584 18.9855 17.9962 18.9878C17.734 18.99 17.4814 18.8892 17.2928 18.7071L11.9998 13.4141L6.70679 18.7071C6.51818 18.8892 6.26558 18.99 6.00339 18.9878C5.74119 18.9855 5.49038 18.8803 5.30497 18.6949C5.11956 18.5095 5.01439 18.2587 5.01211 17.9965C5.00983 17.7343 5.11063 17.4817 5.29279 17.2931L10.5858 12.0001L5.29279 6.70708C5.10532 6.51955 5 6.26525 5 6.00008C5 5.73492 5.10532 5.48061 5.29279 5.29308V5.29308Z",
                                        fill: "current"
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                    className: classnames_default()("xl:hidden ml-3 text-base font-inter leading-6", {
                                        "text-white": isHighlighted
                                    }),
                                    children: feature
                                })
                            ]
                        }, feature);
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                        className: classnames_default()("flex font-inter xl:text-xl xl:leading-8 text-center", "".concat(isHighlighted ? "xl:font-bold" : "xl:font-normal"), {
                            "text-white font-bold ": isHighlighted
                        }),
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "block xl:hidden",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
                                    className: "fill-current",
                                    width: "24",
                                    height: "24",
                                    viewBox: "0 0 24 24",
                                    fill: "none",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                        fillRule: "evenodd",
                                        clipRule: "evenodd",
                                        d: "M13 4C13 3.73478 12.8946 3.48043 12.7071 3.29289C12.5196 3.10536 12.2652 3 12 3C11.7348 3 11.4804 3.10536 11.2929 3.29289C11.1054 3.48043 11 3.73478 11 4V5C9.93913 5 8.92172 5.42143 8.17157 6.17157C7.42143 6.92172 7 7.93913 7 9C7 10.0609 7.42143 11.0783 8.17157 11.8284C8.92172 12.5786 9.93913 13 11 13V17C10.5863 17.0001 10.1828 16.8719 9.84498 16.6332C9.50715 16.3945 9.25159 16.0569 9.1135 15.667C9.02172 15.4215 8.83726 15.2219 8.59981 15.1111C8.36235 15.0002 8.09087 14.987 7.84378 15.0743C7.59668 15.1616 7.39372 15.3424 7.27856 15.5778C7.16341 15.8132 7.14525 16.0844 7.228 16.333C7.5039 17.1129 8.01476 17.7882 8.69027 18.2658C9.36577 18.7434 10.1727 18.9999 11 19V20C11 20.2652 11.1054 20.5196 11.2929 20.7071C11.4804 20.8946 11.7348 21 12 21C12.2652 21 12.5196 20.8946 12.7071 20.7071C12.8946 20.5196 13 20.2652 13 20V19C14.0609 19 15.0783 18.5786 15.8284 17.8284C16.5786 17.0783 17 16.0609 17 15C17 13.9391 16.5786 12.9217 15.8284 12.1716C15.0783 11.4214 14.0609 11 13 11V7C13.4137 6.99994 13.8172 7.12808 14.155 7.3668C14.4929 7.60552 14.7484 7.94307 14.8865 8.333C14.9783 8.57846 15.1627 8.77808 15.4002 8.88892C15.6377 8.99977 15.9091 9.01297 16.1562 8.92569C16.4033 8.83841 16.6063 8.65763 16.7214 8.42223C16.8366 8.18684 16.8548 7.91565 16.772 7.667C16.4961 6.88707 15.9852 6.21182 15.3097 5.7342C14.6342 5.25659 13.8273 5.00009 13 5V4ZM11 7C10.4696 7 9.96086 7.21071 9.58579 7.58579C9.21071 7.96086 9 8.46957 9 9C9 9.53043 9.21071 10.0391 9.58579 10.4142C9.96086 10.7893 10.4696 11 11 11V7ZM13 13V17C13.5304 17 14.0391 16.7893 14.4142 16.4142C14.7893 16.0391 15 15.5304 15 15C15 14.4696 14.7893 13.9609 14.4142 13.5858C14.0391 13.2107 13.5304 13 13 13Z",
                                        fill: "current"
                                    })
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "ml-3 xl:ml-0",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        className: "hidden xl:inline-block",
                                        children: "$"
                                    }),
                                    cost
                                ]
                            })
                        ]
                    })
                ]
            })
        ]
    });
}
function PricingFeatureComparison() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "flex flex-col xl:flex-row xl:space-x-12 xl:h-[448px] w-full max-w-md xl:max-w-none xl:w-auto",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("ul", {
                className: "flex-col hidden h-full pt-24 xl:flex justify-evenly",
                children: [
                    features.map(function(feature) {
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                            className: "py-2 text-xl leading-8",
                            children: feature
                        }, feature);
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                        className: "text-xl leading-8",
                        children: "Cost"
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(PricingFeatureComparisonColumn, {
                title: /*#__PURE__*/ (0,jsx_runtime.jsx)(PricingFeatureComparisonDawnLogo, {}),
                featuresChecked: [
                    0,
                    1,
                    2,
                    3,
                    4
                ],
                cost: "$0-75*",
                isHighlighted: true
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(PricingFeatureComparisonColumn, {
                title: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                    className: "text-xl font-semibold",
                    children: "Sleep Clinics"
                }),
                featuresChecked: [
                    0,
                    3
                ],
                cost: "1000/mo"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(PricingFeatureComparisonColumn, {
                title: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                    className: "text-xl font-semibold",
                    children: "Sleep Therapist"
                }),
                featuresChecked: [
                    0,
                    1,
                    3,
                    4
                ],
                cost: "300/mo"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(PricingFeatureComparisonColumn, {
                title: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                    className: "text-xl font-semibold",
                    children: "Sleep Medication"
                }),
                featuresChecked: [],
                cost: "100/mo"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(PricingFeatureComparisonColumn, {
                title: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                    className: "text-xl font-semibold",
                    children: "OTC Sleep Aids"
                }),
                featuresChecked: [
                    1
                ],
                cost: "20-150/mo"
            })
        ]
    });
}
function PricingFeatureComparisonDawnLogo() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
                className: "block xl:hidden",
                width: "83",
                height: "24",
                viewBox: "0 0 83 24",
                fill: "none",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fillRule: "evenodd",
                        clipRule: "evenodd",
                        d: "M29.3791 17.6695C28.4001 17.6695 27.4996 17.4353 26.6776 16.9668C25.8555 16.4908 25.1979 15.7918 24.7047 14.8696C24.2115 13.9475 23.9648 12.8208 23.9648 11.4897C23.9648 10.1882 24.2152 9.0839 24.7159 8.17662C25.2166 7.26935 25.878 6.58146 26.7 6.11295C27.5221 5.637 28.4151 5.39903 29.3791 5.39903C30.3058 5.39903 31.1652 5.62213 31.9574 6.06833C32.426 6.32985 32.8408 6.65141 33.2016 7.033V0H35.6453V17.4353H33.2016V15.9816C32.8609 16.36 32.4686 16.6847 32.0246 16.9556C31.2399 17.4316 30.3581 17.6695 29.3791 17.6695ZM33.2016 12.159V10.72C33.2016 10.1027 33.0447 9.55613 32.7308 9.08018C32.417 8.5968 32.0022 8.21752 31.4865 7.94237C30.9784 7.65977 30.4366 7.51848 29.8611 7.51848C28.8971 7.51848 28.09 7.84197 27.4398 8.48896C26.7897 9.12852 26.4646 10.1287 26.4646 11.4897C26.4646 12.8431 26.7897 13.8471 27.4398 14.5015C28.0975 15.1485 28.9046 15.472 29.8611 15.472C30.459 15.472 31.012 15.3307 31.5202 15.0481C32.0284 14.7581 32.4356 14.3639 32.742 13.8657C33.0484 13.3674 33.2016 12.7985 33.2016 12.159ZM42.5934 17.6693C41.6966 17.6693 40.9082 17.5281 40.2282 17.2455C39.5556 16.9629 39.0325 16.5576 38.6588 16.0296C38.2851 15.5016 38.0983 14.8657 38.0983 14.1221C38.0983 13.3263 38.3076 12.6682 38.7261 12.1476C39.152 11.627 39.7349 11.2255 40.4748 10.9429C41.2221 10.6528 42.0703 10.4632 43.0194 10.374C44.4318 10.2327 45.4257 10.0951 46.0011 9.96124C46.5841 9.82738 46.8755 9.60799 46.8755 9.30309V9.28078C46.8755 8.67841 46.6177 8.22105 46.102 7.90871C45.5864 7.59637 44.8503 7.4402 43.8937 7.4402C42.8849 7.4402 42.1039 7.61868 41.5509 7.97564C41.0054 8.32517 40.7326 8.88292 40.7326 9.64889H38.3449C38.3449 8.74162 38.5803 7.97192 39.0511 7.33981C39.5294 6.70769 40.1871 6.22802 41.024 5.90081C41.861 5.56616 42.8213 5.39884 43.9049 5.39884C44.8989 5.39884 45.8031 5.55129 46.6177 5.85619C47.4397 6.15366 48.0936 6.59986 48.5794 7.19479C49.0651 7.78973 49.308 8.52967 49.308 9.41464V15.0702C49.308 15.3454 49.3192 15.6131 49.3416 15.8734C49.3641 16.1262 49.4052 16.3531 49.4649 16.5538C49.5322 16.7844 49.6107 16.974 49.7003 17.1228C49.7975 17.2715 49.876 17.3756 49.9358 17.4351H47.5145C47.4696 17.3905 47.4024 17.2975 47.3127 17.1562C47.2305 17.0075 47.1557 16.8364 47.0885 16.6431C47.0296 16.4802 46.9821 16.2973 46.9461 16.0944C46.7688 16.2969 46.5584 16.4835 46.315 16.6542C45.8666 16.974 45.3248 17.2231 44.6896 17.4016C44.0619 17.5801 43.3631 17.6693 42.5934 17.6693ZM43.0978 15.6614C43.7928 15.6614 44.4243 15.5536 44.9923 15.3379C45.5677 15.1148 46.0273 14.7802 46.3711 14.334C46.7148 13.8804 46.8867 13.3115 46.8867 12.6273V11.6029C46.534 11.7049 46.1379 11.7935 45.6985 11.8687C45.011 11.9803 44.301 12.0733 43.5686 12.1476C42.5598 12.2369 41.8013 12.4116 41.2931 12.6719C40.7849 12.9247 40.5308 13.3486 40.5308 13.9436C40.5308 14.5162 40.7401 14.9475 41.1586 15.2376C41.5845 15.5201 42.231 15.6614 43.0978 15.6614ZM62.3842 17.4353L59.9901 8.1335L57.6313 17.4353H54.2572L51.735 5.58867H54.2572L56.0152 15.5873L58.6626 5.58867H61.3081L63.9826 15.6127L65.7247 5.58867H68.2469L65.7359 17.4353H62.3842ZM81.6305 17.4351H79.198V10.5301C79.198 9.95008 79.1083 9.44067 78.9289 9.0019C78.7496 8.5557 78.4544 8.2099 78.0434 7.96449C77.6323 7.71164 77.0831 7.58522 76.3955 7.58522C75.7902 7.58522 75.2409 7.73395 74.7477 8.03142C74.262 8.32889 73.8733 8.73418 73.5819 9.24731C73.2979 9.75301 73.1559 10.3293 73.1559 10.9763V17.4351H70.7234V5.58847H73.1559V7.3573C73.5575 6.83584 74.047 6.40612 74.6244 6.06814C75.3941 5.62194 76.2349 5.39884 77.1466 5.39884C78.0882 5.39884 78.8916 5.58103 79.5567 5.94543C80.2292 6.30239 80.7412 6.81552 81.0924 7.48482C81.4511 8.14669 81.6305 8.93869 81.6305 9.86084V17.4351Z",
                        fill: "white"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fillRule: "evenodd",
                        clipRule: "evenodd",
                        d: "M17.8239 15.043C18.338 13.9845 18.6257 12.801 18.6257 11.552C18.6257 7.04179 14.8749 3.3855 10.2482 3.3855C5.62146 3.3855 1.87074 7.04179 1.87074 11.552C1.87074 12.9116 2.21155 14.1936 2.81444 15.3212H9.63592L1.63745 16.9608C0.213255 17.2528 0.426425 19.3446 1.88033 19.3446H13.397L6.5201 21.008C5.18647 21.3306 5.34077 23.2702 6.70871 23.3788L14.4941 23.997C15.0109 24.038 15.4632 23.6532 15.5043 23.1376C15.5455 22.6219 15.1598 22.1707 14.643 22.1296L11.036 21.8432L19.2931 19.8459C20.6813 19.5102 20.4372 17.4714 19.0088 17.4714H8.47581L17.1105 15.7014C17.4642 15.6289 17.7302 15.3667 17.8239 15.043Z",
                        fill: "url(#paint0_linear_762_873)"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("defs", {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("linearGradient", {
                            id: "paint0_linear_762_873",
                            x1: "20.2164",
                            y1: "3.3855",
                            x2: "3.63783",
                            y2: "26.1584",
                            gradientUnits: "userSpaceOnUse",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                    offset: "0.166667",
                                    stopColor: "#FF8F5B"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                    offset: "0.822917",
                                    stopColor: "#536DE2"
                                })
                            ]
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
                className: "hidden xl:block",
                width: "68",
                height: "50",
                viewBox: "0 0 68 50",
                fill: "none",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fillRule: "evenodd",
                        clipRule: "evenodd",
                        d: "M42.6238 13.6237C43.2247 12.3866 43.5608 11.0035 43.5608 9.54393C43.5608 4.27296 39.1775 0 33.7704 0C28.3633 0 23.98 4.27296 23.98 9.54393C23.98 11.1328 24.3783 12.631 25.0829 13.9488H33.0549L23.7074 15.865C22.043 16.2061 22.2921 18.6508 23.9912 18.6508H37.4503L29.4135 20.5948C27.855 20.9718 28.0353 23.2385 29.6339 23.3654L38.7324 24.0878C39.3364 24.1358 39.865 23.6861 39.913 23.0835C39.9611 22.4809 39.5105 21.9535 38.9065 21.9055L34.6911 21.5708L44.3409 19.2367C45.9632 18.8443 45.6779 16.4616 44.0086 16.4616H31.6991L41.7901 14.3931C42.2034 14.3084 42.5143 14.0019 42.6238 13.6237Z",
                        fill: "url(#paint0_linear_762_381)"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fillRule: "evenodd",
                        clipRule: "evenodd",
                        d: "M6.63166 50C5.48756 50 4.43517 49.7263 3.47448 49.1787C2.51379 48.6225 1.74524 47.8056 1.16882 46.7279C0.592406 45.6502 0.304199 44.3335 0.304199 42.7779C0.304199 41.2569 0.596773 39.9663 1.18192 38.906C1.76707 37.8457 2.53999 37.0418 3.50068 36.4943C4.46137 35.9381 5.50503 35.66 6.63166 35.66C7.71462 35.66 8.71898 35.9207 9.64474 36.4422C10.1925 36.7478 10.6772 37.1236 11.0989 37.5695V29.3503H13.9547V49.7263H11.0989V48.0275C10.7007 48.4697 10.2422 48.8491 9.72334 49.1657C8.80631 49.7219 7.77576 50 6.63166 50ZM11.0989 43.56V41.8783C11.0989 41.157 10.9155 40.5182 10.5487 39.962C10.1819 39.3971 9.69714 38.9538 9.09452 38.6323C8.50064 38.302 7.86746 38.1369 7.19497 38.1369C6.06835 38.1369 5.12512 38.5149 4.3653 39.2711C3.60548 40.0185 3.22557 41.1874 3.22557 42.7779C3.22557 44.3596 3.60548 45.5329 4.3653 46.2977C5.13385 47.0538 6.07708 47.4319 7.19497 47.4319C7.89366 47.4319 8.53994 47.2667 9.13382 46.9365C9.72771 46.5975 10.2037 46.1369 10.5618 45.5546C10.9198 44.9723 11.0989 44.3075 11.0989 43.56ZM22.0747 49.9998C21.0266 49.9998 20.1052 49.8347 19.3105 49.5044C18.5245 49.1742 17.9131 48.7005 17.4764 48.0835C17.0398 47.4664 16.8214 46.7233 16.8214 45.8542C16.8214 44.9243 17.066 44.1552 17.555 43.5468C18.0529 42.9384 18.7341 42.4691 19.5987 42.1389C20.472 41.7999 21.4633 41.5783 22.5725 41.474C24.2231 41.3089 25.3847 41.1481 26.0572 40.9916C26.7384 40.8352 27.079 40.5788 27.079 40.2225V40.1964C27.079 39.4925 26.7777 38.958 26.1751 38.5929C25.5724 38.2279 24.7122 38.0454 23.5943 38.0454C22.4153 38.0454 21.5026 38.254 20.8563 38.6712C20.2188 39.0796 19.9 39.7315 19.9 40.6266H17.1096C17.1096 39.5663 17.3847 38.6668 17.9349 37.9281C18.4939 37.1894 19.2624 36.6288 20.2406 36.2464C21.2188 35.8553 22.341 35.6598 23.6074 35.6598C24.769 35.6598 25.8257 35.8379 26.7777 36.1942C27.7384 36.5419 28.5025 37.0633 29.0702 37.7586C29.6379 38.4539 29.9218 39.3186 29.9218 40.3529V46.9623C29.9218 47.2839 29.9349 47.5968 29.9611 47.901C29.9873 48.1964 30.0353 48.4615 30.1052 48.6962C30.1838 48.9656 30.2755 49.1872 30.3803 49.361C30.4938 49.5348 30.5855 49.6565 30.6554 49.7261H27.8257C27.7733 49.6739 27.6947 49.5653 27.5899 49.4001C27.4938 49.2263 27.4065 49.0264 27.3279 48.8005C27.259 48.6101 27.2035 48.3963 27.1615 48.1592C26.9542 48.3959 26.7084 48.614 26.424 48.8135C25.9 49.1872 25.2668 49.4784 24.5244 49.6869C23.7908 49.8955 22.9742 49.9998 22.0747 49.9998ZM22.6642 47.6533C23.4764 47.6533 24.2144 47.5272 24.8781 47.2752C25.5506 47.0145 26.0877 46.6234 26.4895 46.1019C26.8912 45.5718 27.0921 44.9069 27.0921 44.1074V42.9102C26.6798 43.0294 26.2169 43.133 25.7034 43.2209C24.9 43.3512 24.0703 43.4599 23.2144 43.5468C22.0354 43.6511 21.1489 43.8553 20.555 44.1595C19.9611 44.455 19.6642 44.9504 19.6642 45.6456C19.6642 46.3149 19.9087 46.8189 20.3978 47.1579C20.8956 47.4881 21.6511 47.6533 22.6642 47.6533ZM45.2034 49.7263L42.4055 38.8556L39.6488 49.7263H35.7057L32.7581 35.8816H35.7057L37.7602 47.5666L40.8541 35.8816H43.9458L47.0714 47.5963L49.1073 35.8816H52.0549L49.1204 49.7263H45.2034ZM67.6957 49.7261H64.853V41.6565C64.853 40.9786 64.7482 40.3833 64.5385 39.8705C64.3289 39.3491 63.984 38.9449 63.5036 38.6581C63.0233 38.3626 62.3814 38.2149 61.5779 38.2149C60.8705 38.2149 60.2285 38.3887 59.6521 38.7363C59.0844 39.084 58.6303 39.5576 58.2897 40.1573C57.9578 40.7483 57.7919 41.4219 57.7919 42.178V49.7261H54.9491V35.8814H57.7919V37.9485C58.2612 37.3391 58.8332 36.8369 59.508 36.4419C60.4076 35.9205 61.3901 35.6598 62.4556 35.6598C63.556 35.6598 64.4949 35.8727 65.2722 36.2985C66.0582 36.7157 66.6564 37.3154 67.0669 38.0976C67.4861 38.8711 67.6957 39.7966 67.6957 40.8743V49.7261Z",
                        fill: "white"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("defs", {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("linearGradient", {
                            id: "paint0_linear_762_381",
                            x1: "45.4199",
                            y1: "0",
                            x2: "26.0451",
                            y2: "26.6139",
                            gradientUnits: "userSpaceOnUse",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                    offset: "0.166667",
                                    stopColor: "#FF8F5B"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                    offset: "0.822917",
                                    stopColor: "#536DE2"
                                })
                            ]
                        })
                    })
                ]
            })
        ]
    });
}

// EXTERNAL MODULE: ./components/Gradient/index.ts + 1 modules
var Gradient = __webpack_require__(1824);
;// CONCATENATED MODULE: ./components/page-sections/WhyDawn/WhyDawn.tsx


function WhyDawn() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("section", {
        className: "overflow-hidden bg-dawnDark-700 py-22 md:pt-30 md:pb-30",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "relative hidden md:block",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Gradient/* Gradient */.p, {
                        color: "purple",
                        scale: 6,
                        opacity: 0.15,
                        left: "-40rem",
                        top: "-15rem"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Gradient/* Gradient */.p, {
                        color: "orange",
                        scale: 7,
                        opacity: 0.15,
                        left: "-60rem",
                        top: "-10rem"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Gradient/* Gradient */.p, {
                        color: "purple",
                        scale: 5,
                        opacity: 0.15,
                        right: "-30rem",
                        top: "-10rem"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Gradient/* Gradient */.p, {
                        color: "orange",
                        scale: 5,
                        opacity: 0.1,
                        right: "-40rem",
                        top: "-10rem"
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "relative flex justify-center space-y-22 md:space-y-30",
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "max-w-[1034px] text-white mx-8",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                            className: "md:text-5xl md:leading-14 font-semibold text-2.5xl leading-8",
                            children: "Why Dawn?"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "flex flex-col mt-4 space-y-6 text-base md:flex-row md:space-y-0 md:space-x-6 md:mt-8 md:text-xl md:leading-8 font-inter",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "flex-1",
                                    children: "Dawn\u2019s CBT-I treatment is proven to have long-lasting effects, without the unpleasant side effects. Can you say the same about over-the-counter treatments, like melatonin, or sleeping pills, like Ambien?"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "flex-1",
                                    children: "Unlike in-person sleep clinics and sleep therapists, Dawn\u2019s sleep program is completely on your terms. You can reach out to your dedicated sleep coach 24/7 from the comfort of your own home, and only for $89 a month for an average of three months!"
                                })
                            ]
                        })
                    ]
                })
            })
        ]
    });
}

;// CONCATENATED MODULE: ./components/page-sections/WhyDawn/index.ts


// EXTERNAL MODULE: ./components/page-sections/Quote/Quote.tsx
var Quote = __webpack_require__(54124);
;// CONCATENATED MODULE: ./components/page-sections/Quote/index.ts


// EXTERNAL MODULE: ./public/images/people/jocelyn-profile.jpg
var jocelyn_profile = __webpack_require__(46877);
// EXTERNAL MODULE: ./components/page-sections/Insurance/index.ts + 11 modules
var Insurance = __webpack_require__(35540);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(41664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
;// CONCATENATED MODULE: ./modules/pricing/GettingStartedIsSimple.tsx



function GettingStartedIsSimple() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("section", {
        className: "overflow-hidden bg-dawnDark-700 py-22 md:py-30",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "relative hidden md:block",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Gradient/* Gradient */.p, {
                        color: "purple",
                        scale: 6,
                        opacity: 0.15,
                        left: "-40rem",
                        top: "-15rem"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Gradient/* Gradient */.p, {
                        color: "orange",
                        scale: 7,
                        opacity: 0.15,
                        left: "-60rem",
                        top: "-10rem"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Gradient/* Gradient */.p, {
                        color: "purple",
                        scale: 5,
                        opacity: 0.15,
                        right: "-30rem",
                        top: "-10rem"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Gradient/* Gradient */.p, {
                        color: "orange",
                        scale: 5,
                        opacity: 0.1,
                        right: "-40rem",
                        top: "-10rem"
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "relative flex justify-center space-y-22 md:space-y-30",
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "mx-8 text-white",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                            className: "md:text-5xl md:leading-14 text-center font-semibold text-2.5xl leading-8",
                            children: "Getting started is simple"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("ul", {
                            className: "flex flex-col mt-10 space-y-10 max-w-7xl md:mt-16 md:flex-row md:space-y-0 md:space-x-20",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(ListItem, {
                                    icon: /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
                                        viewBox: "0 0 48 48",
                                        fill: "none",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("circle", {
                                                cx: "24.333",
                                                cy: "24",
                                                r: "23.5",
                                                stroke: "url(#paint0_linear_2585_1124)"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                                d: "M20.0955 30.684H28.9635V33H20.0955V30.684ZM26.2035 15.264V33H23.0595V18.324C22.9715 18.404 22.7595 18.512 22.4235 18.648C22.0875 18.776 21.6795 18.9 21.1995 19.02C20.7275 19.132 20.2315 19.212 19.7115 19.26V16.692C20.2315 16.628 20.7275 16.516 21.1995 16.356C21.6795 16.196 22.0915 16.02 22.4355 15.828C22.7795 15.628 23.0075 15.44 23.1195 15.264H26.2035Z",
                                                fill: "white"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("defs", {
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("linearGradient", {
                                                    id: "paint0_linear_2585_1124",
                                                    x1: "48.333",
                                                    y1: "1.99889e-06",
                                                    x2: "10.2999",
                                                    y2: "54.9043",
                                                    gradientUnits: "userSpaceOnUse",
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                                            stopColor: "#FF8F5B"
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                                            offset: "1",
                                                            stopColor: "#536DE2"
                                                        })
                                                    ]
                                                })
                                            })
                                        ]
                                    }),
                                    title: "Send us your insurance details",
                                    body: "Confirm your in-network status by submitting your insurance information and creating a Dawn account."
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(ListItem, {
                                    icon: /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
                                        viewBox: "0 0 48 48",
                                        fill: "none",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("circle", {
                                                cx: "24",
                                                cy: "24",
                                                r: "23.5",
                                                stroke: "url(#paint0_linear_2585_1132)"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                                d: "M18.2025 33V30.372C18.2665 30.14 18.4665 29.832 18.8025 29.448C19.1465 29.056 19.5625 28.628 20.0505 28.164C20.5465 27.7 21.0625 27.232 21.5985 26.76C22.1345 26.288 22.6345 25.852 23.0985 25.452C23.6585 24.964 24.2065 24.456 24.7425 23.928C25.2785 23.4 25.7225 22.844 26.0745 22.26C26.4265 21.676 26.6025 21.056 26.6025 20.4C26.6025 19.528 26.3945 18.844 25.9785 18.348C25.5625 17.844 24.9265 17.592 24.0705 17.592C23.3745 17.592 22.8225 17.744 22.4145 18.048C22.0065 18.344 21.7145 18.76 21.5385 19.296C21.3625 19.832 21.2745 20.456 21.2745 21.168H18.0945C18.0945 19.928 18.3225 18.852 18.7785 17.94C19.2345 17.02 19.9105 16.308 20.8065 15.804C21.7025 15.3 22.8025 15.048 24.1065 15.048C25.3625 15.048 26.4105 15.284 27.2505 15.756C28.0905 16.22 28.7185 16.86 29.1345 17.676C29.5585 18.484 29.7705 19.4 29.7705 20.424C29.7705 21.12 29.6385 21.776 29.3745 22.392C29.1185 23 28.7825 23.568 28.3665 24.096C27.9505 24.624 27.5065 25.108 27.0345 25.548C26.5625 25.988 26.1105 26.388 25.6785 26.748C24.9745 27.324 24.3465 27.856 23.7945 28.344C23.2505 28.824 22.8065 29.244 22.4625 29.604C22.1265 29.964 21.9185 30.26 21.8385 30.492H29.7465V33H18.2025Z",
                                                fill: "white"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("defs", {
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("linearGradient", {
                                                    id: "paint0_linear_2585_1132",
                                                    x1: "48",
                                                    y1: "1.99889e-06",
                                                    x2: "9.96692",
                                                    y2: "54.9043",
                                                    gradientUnits: "userSpaceOnUse",
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                                            stopColor: "#FF8F5B"
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                                            offset: "1",
                                                            stopColor: "#536DE2"
                                                        })
                                                    ]
                                                })
                                            })
                                        ]
                                    }),
                                    title: "Get verified in 24 hours",
                                    body: "Our care coordinators will confirm your in-network status, and walk you through any costs you can expect."
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(ListItem, {
                                    icon: /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
                                        viewBox: "0 0 49 48",
                                        fill: "none",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("circle", {
                                                cx: "24.666",
                                                cy: "24",
                                                r: "23.5",
                                                stroke: "url(#paint0_linear_2585_1140)"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                                d: "M27.2925 23.676C27.9965 23.7 28.5845 23.896 29.0565 24.264C29.5365 24.632 29.9005 25.124 30.1485 25.74C30.3965 26.348 30.5205 27.028 30.5205 27.78C30.5205 28.78 30.3165 29.696 29.9085 30.528C29.5085 31.36 28.8845 32.024 28.0365 32.52C27.1885 33.016 26.1045 33.264 24.7845 33.264C23.6645 33.264 22.7285 33.12 21.9765 32.832C21.2245 32.536 20.6245 32.124 20.1765 31.596C19.7285 31.06 19.4045 30.436 19.2045 29.724C19.0045 29.012 18.9045 28.244 18.9045 27.42C18.9045 27.412 18.9045 27.404 18.9045 27.396C18.9045 27.388 18.9045 27.38 18.9045 27.372H22.0725C22.0725 27.38 22.0725 27.388 22.0725 27.396C22.0725 27.404 22.0725 27.412 22.0725 27.42C22.0725 28.292 22.1845 28.968 22.4085 29.448C22.6325 29.928 22.9485 30.264 23.3565 30.456C23.7645 30.648 24.2525 30.744 24.8205 30.744C25.5805 30.744 26.1885 30.504 26.6445 30.024C27.1085 29.536 27.3405 28.76 27.3405 27.696C27.3405 27.288 27.2965 26.916 27.2085 26.58C27.1205 26.236 26.9685 25.944 26.7525 25.704C26.5445 25.456 26.2605 25.264 25.9005 25.128C25.5405 24.992 25.0845 24.924 24.5325 24.924H23.9085V22.62H24.5325C25.0765 22.62 25.5285 22.548 25.8885 22.404C26.2485 22.26 26.5325 22.068 26.7405 21.828C26.9565 21.58 27.1085 21.3 27.1965 20.988C27.2925 20.676 27.3405 20.352 27.3405 20.016C27.3405 19.168 27.1125 18.552 26.6565 18.168C26.2085 17.784 25.6125 17.592 24.8685 17.592C24.0445 17.592 23.3725 17.816 22.8525 18.264C22.3325 18.712 22.0725 19.52 22.0725 20.688H18.9045C18.9045 19.904 19.0165 19.172 19.2405 18.492C19.4725 17.812 19.8245 17.216 20.2965 16.704C20.7685 16.184 21.3765 15.78 22.1205 15.492C22.8725 15.196 23.7685 15.048 24.8085 15.048C26.1365 15.048 27.2165 15.272 28.0485 15.72C28.8885 16.168 29.5085 16.76 29.9085 17.496C30.3165 18.224 30.5205 19.008 30.5205 19.848C30.5205 20.52 30.3965 21.14 30.1485 21.708C29.9005 22.276 29.5365 22.74 29.0565 23.1C28.5845 23.452 27.9965 23.644 27.2925 23.676Z",
                                                fill: "white"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("defs", {
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("linearGradient", {
                                                    id: "paint0_linear_2585_1140",
                                                    x1: "48.666",
                                                    y1: "1.99889e-06",
                                                    x2: "10.6329",
                                                    y2: "54.9043",
                                                    gradientUnits: "userSpaceOnUse",
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                                            stopColor: "#FF8F5B"
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                                            offset: "1",
                                                            stopColor: "#536DE2"
                                                        })
                                                    ]
                                                })
                                            })
                                        ]
                                    }),
                                    title: "Start sleeping better",
                                    body: "Our Care Team will pair you with a sleep coach who you\u2019ll have unlimited messaging and weekly calls with."
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "flex justify-center mt-12 md:mt-16",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                href: "/questionnaire",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                    className: "flex items-center justify-center w-full max-w-md px-8 py-4 text-sm font-medium tracking-widest text-white uppercase rounded-full leading-0 md:w-auto bg-gradient-to-tr from-dawnOrange-500 to-dawnPurple-500 xl:py-6 md:text-base",
                                    children: "Submit My Details"
                                })
                            })
                        })
                    ]
                })
            })
        ]
    });
}
function ListItem(param) {
    var icon = param.icon, title = param.title, body = param.body;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "w-10 h-10 md:w-12 md:h-12 md:mx-auto",
                children: icon
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "mt-6 text-base font-semibold md:text-center md:text-xl md:leading-8",
                children: title
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "mt-2 font-inter md:text-xl md:leading-8 md:text-center",
                children: body
            })
        ]
    });
}

// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(25675);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
;// CONCATENATED MODULE: ./modules/pricing/WeAcceptMajorInsuranceProviders.tsx



function WeAcceptMajorInsuranceProviders() {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "flex justify-center pt-22 pb-22 md:pt-30 md:pb-18",
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "flex flex-col items-center mx-8 md:flex-row md:space-x-22 xl:space-x-34",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "relative md:hidden",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                        src: "/images/pricing/we_accept_major_insurance_providers_mobile.png",
                        alt: "",
                        width: "311",
                        height: "280"
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "hidden md:block",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                        src: "/images/pricing/we_accept_major_insurance_providers.png",
                        alt: "",
                        width: "501",
                        height: "328"
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "max-w-[394px] mt-4 md:mt-0",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                            className: "font-semibold text-2.5xl leading-8 md:text-5xl md:leading-14",
                            children: "We accept major insurance providers"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                            className: "mt-4 text-base font-inter md:text-xl md:leading-8",
                            children: "If your insurance plan is in-network with Dawn, it\u2019s likely that it will cover a portion of the cost of your therapy plan."
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "mt-4",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                href: "/questionnaire",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                    className: "text-base font-bold text-dawnPurple-500 md:text-xl md:leading-8",
                                    children: "Get Started"
                                })
                            })
                        })
                    ]
                })
            ]
        })
    });
}

;// CONCATENATED MODULE: ./pages/pricing.tsx












function Pricing() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)((head_default()), {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("title", {
                        children: "Pricing | Dawn Health"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        name: "description",
                        content: "How much our program costs."
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        name: "viewport",
                        content: "initial-scale=1.0, width=device-width"
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("main", {
                className: "text-dawnDark-500",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Intro/* IntroBase */.O, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "max-w-[608px] md:pt-28 pt-22 mx-auto",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h1", {
                                        className: "xl:text-5.5xl text-5xl leading-12 xl:leading-18 font-bold text-center text-white",
                                        children: "Pricing"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                        className: "mx-6 mt-6 text-base text-center text-white md:mx-0 font-inter xl:leading-8 xl:text-xl",
                                        children: "We deliver affordable, evidence-based sleep therapy and help you overcome sleep troubles from the convenience of your home. We\u2019re in-network with many insurance providers!"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "flex justify-center mx-6 mt-6",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                            href: "/questionnaire",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                className: "flex items-center justify-center w-full max-w-md px-8 py-4 text-sm font-medium leading-none tracking-widest text-white uppercase rounded-full md:w-auto bg-gradient-to-tr from-dawnOrange-500 to-dawnPurple-500 xl:py-6 md:text-base",
                                                children: "Get Started"
                                            })
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "pb-12 md:pt-32 md:pb-22 pt-26 ",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Insurance/* InsuranceLogos */.w, {})
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(WeAcceptMajorInsuranceProviders, {}),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(GettingStartedIsSimple, {}),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "flex flex-col items-center justify-center px-6 pt-22 md:pt-30",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "text-dawnDark-700",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                                    className: "mx-auto font-semibold text-2.5xl leading-8 mt-4 text-center md:text-5xl md:leading-14",
                                    children: "Dawn is more affordable than alternatives"
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "mt-12 md:mt-16",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(PricingFeatureComparison, {}),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "pt-24 pb-6 italic text-center justify-self-end md:text-base text-dawnDark-400",
                                        children: "* Cost depends on insurance coverage"
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(WhyDawn, {}),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Quote/* Quote */.p, {
                        text: "I was ready to pay hundreds of dollars [for] a sleep therapist...I found [Dawn] online and I\u2019m so glad I did because I saved money and I was able to sleep...it really reduced my stress and was very supportive for me.",
                        source: "Jocelyn Diles",
                        sourceTitle: "Feminine Embodiment Coach",
                        sourceImageStatic: jocelyn_profile/* default */.Z
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(CallToAction/* CallToAction */.J, {
                        title: "Cure your insomnia today.",
                        text: "Craving good sleep? Talk to a sleep coach and find out more about Dawn\u2019s program for curing sleep problems"
                    })
                ]
            })
        ]
    });
};


/***/ })

}]);